import { handleError } from "../../../utils/handleError";
import store from "../../../redux/store";
import { updateFpAppV4Data } from "../../../redux/fpAppV4Slice";
import { v4 as uuidv4 } from "uuid";
import { liveEditor } from "@/utils/liveEditor";

// Track query IDs that were stopped locally to prevent their results from
// overwriting the editor content via setContent after the user clicked Stop.
const stoppedQueryIds = new Set();

export const markQueryAsStopped = (qid) => stoppedQueryIds.add(qid);

const updateQueryStatus = (messageData) => {
  try {
    const queryAnswersOrg = store.getState().fpAppV4Data.queryAnswers;
    const workspaceType = store.getState().fpAppV4Data.type;
    const currentWorkspaceId = store.getState().fpAppV4Data.workspaceId;
    const queryAnswers = JSON.parse(JSON.stringify(queryAnswersOrg));

    // Filter out messages that don't belong to the current workspace
    if (
      messageData.workspace_id &&
      messageData.workspace_id !== currentWorkspaceId
    ) {
      return;
    }

    // Prevent query status updates for template workspaces
    // Templates should not receive query execution updates
    if (
      workspaceType === "private_doc_editor_template" ||
      workspaceType === "editor_template"
    ) {
      return;
    }

    let isFailedQuery = false;
    let queryAlreadyExists = false;
    for (const queryAnswer of queryAnswers) {
      if (queryAnswer.qid === messageData._id) {
        queryAlreadyExists = true;
        if (queryAnswer.status === "failed") isFailedQuery = true;
        queryAnswer.status = messageData.status;
        queryAnswer.toolId = messageData.tool_id;
        queryAnswer.toolResponse = messageData.result;
        break;
      }
    }

    if (!queryAlreadyExists && workspaceType === "querygrid") {
      queryAnswers.push({
        qid: messageData._id,
        status: messageData.status,
        toolId: messageData.tool_id,
        toolResponse: messageData.result,
      });
    }

    if (isFailedQuery && workspaceType !== "querygrid") return;

    store.dispatch(
      updateFpAppV4Data({
        queryAnswers,
      })
    );

    if (messageData.status === "completed") {
      if (stoppedQueryIds.has(messageData._id)) {
        stoppedQueryIds.delete(messageData._id);
      } else if (workspaceType === "querygrid" || workspaceType === "chat") {
        // do nothing - these workspace types don't use the editor
      } else {
        // The report may have unmounted since this query was sent; a
        // destroyed tiptap v3 editor throws on commands (#11904).
        const live = liveEditor(window.fp?.editor);
        if (live) {
          live.commands.setContent(messageData.new_content);
          live.trigger = uuidv4();
        }
      }
    }
  } catch (error) {
    handleError({
      error,
      location: "updateQueryStatus",
    });
  }
};

export default updateQueryStatus;
